/**
 * Chat History Skeleton Component
 * Loading placeholder for chat history list
 */

import { range } from 'lodash';
import React from 'react';

import SkeletonSVG from '../../../Loading/SkeletonSVG';
import { SkeletonContainer } from './ChatHistory.styled';

const RECT_SIZE = 16 * 1.4;
const PADDING = 18;
const ROW_COUNT = 5;
const TOTAL_HEIGHT = (RECT_SIZE + PADDING) * ROW_COUNT - PADDING; // Subtract padding for the last row

const SmallRow: React.FC<{ index: number }> = ({ index }) => {
  return <rect x={0} y={(RECT_SIZE + PADDING) * index} width={'100%'} height={RECT_SIZE} />;
};

/**
 * ChatHistorySkeleton Component
 * Displays placeholder items while chat history is loading
 */
const ChatHistorySkeleton: React.FC = () => {
  return (
    <SkeletonContainer>
        <SkeletonSVG preserveAspectRatio="none" className="w-100" style={{ height: TOTAL_HEIGHT }}>
          <g>
            {range(ROW_COUNT).map((i) => (
              <SmallRow key={i} index={i} />
            ))}
          </g>
        </SkeletonSVG>
    </SkeletonContainer>
  );
};

export default ChatHistorySkeleton;

